module.exports = __webpack_public_path__ + "img/dangd.b26ac583.gif";